import React, { Component } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import defaultPropertiesUpdateFn from '../../models/form/defaultPropertiesUpdateFn';
import withValidator from '../../models/form/withValidator';
import contentRules from '../../models/form/rules/content';
import nameRules from '../../models/form/rules/name';
import subjectRules from '../../models/form/rules/subject';
import descriptionRules from '../../models/form/rules/description';
import LoadingButton from '../../../shared/ui/LoadingButton';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    content: { rules: contentRules },
    name: { rules: nameRules },
    subject: { rules: subjectRules },
    description: { rules: descriptionRules },
  },
};

class NotificationDetailsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        content: '',
        name: '',
        subject: '',
        description: ''

      },
      properties: {
        content: this.props.initialValues.content,
        name: this.props.initialValues.name,
        subject: this.props.initialValues.subject,
        description: this.props.initialValues.description,
      },
      errorFeedback: {},
      isFormDisabled: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled:
        nextProps.hasErrors || !Object.keys(nextProps.touched).length,
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    const callback = () => {
      if (Object.keys(this.state.cssValidationClasses).includes(name)) {
        this.props.validateField(name, value);
      }
    };
    this.setState(defaultPropertiesUpdateFn(name, value), callback);
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      content: this.state.properties.content,
      name: this.state.properties.name,
      subject: this.state.properties.subject,
      description: this.state.properties.description,
    };

    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <div className="form-group">
          <label htmlFor="name">
            Name <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.name}
            id="name"
            name="name"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="text"
            value={this.state.properties.name}
          />
          <FormFeedback>{this.state.errorFeedback.name}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="name">
            Subject <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.subject}
            id="subject"
            name="subject"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="text"
            value={this.state.properties.subject}
          />
          <FormFeedback>{this.state.errorFeedback.subject}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="content">
            Content <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.content}
            id="content"
            name="content"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            rows="5"
            type="textarea"
            value={this.state.properties.content}
          />
          <FormFeedback>{this.state.errorFeedback.content}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="content">
            Description <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.description}
            id="description"
            name="description"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            rows="5"
            type="textarea"
            value={this.state.properties.description}
          />
          <FormFeedback>{this.state.errorFeedback.description}</FormFeedback>
        </div>
        <div style={{ textAlign: 'right' }}>
          <LoadingButton
            primary
            text="Submit"
            isLoading={this.props.isLoading}
            disabled={this.state.isFormDisabled}
          />
        </div>
      </Form>
    );
  }
}

export default withValidator(NotificationDetailsForm, validatorConfig);
